import { createAction, props } from '@ngrx/store';
import { ContactPerson, Event, Exhibitor, ExhibitorCardData, TabClickEvent } from '@planone/bau365/util-fair-data';
import { FlatLinkClickEvent } from '@planone/shared/util-interfaces';

import {
  BrandSearchResultItem,
  CombinedSearchResultItem,
  ExhibitorSearchResultItem,
} from '../../../interfaces/exhibitor.interfaces';

export const exhibitorsShareButtonClicked = createAction(
  '[Exhibitor Page] Social share',
  props<{
    network: string;
    item: ExhibitorCardData | CombinedSearchResultItem;
    entityType: string;
    fairId: string;
    pageContext: string;
  }>()
);

export const exhibitorsShareButtonClickedContactPerson = createAction(
  '[Exhibitor Contact Person Page] Social share',
  props<{
    network: string;
    exhibitor: Exhibitor;
    event?: Event;
    contactPerson: ContactPerson;
    entityType: string;
    fairId: string;
    pageContext: string;
  }>()
);

export const exhibitorsShareDialogOpened = createAction(
  '[Exhibitor Page] Social share dialog ',
  props<{
    contentType: string;
    pageContext: string;
    context: string;
    exhibitor: ExhibitorCardData | BrandSearchResultItem | ExhibitorSearchResultItem;
  }>()
);

export const exhibitorsTrackedItemClicked = createAction(
  '[Exhibitor Page] Tracked item clicked',
  props<FlatLinkClickEvent>()
);

export const showAllToJumpToSearch = createAction(
  '[Exhibitor Page] Show all',
  props<{
    exhibitor_id: string;
    exhibitor_name: string;
    context: string;
    entity_type: string;
  }>()
);

export const exhibitorsTabClicked = createAction('[Exhibitor Page] Tab option clicked', props<TabClickEvent>());

export const exhibitorsPageView = createAction(
  '[Exhibitor Page] Page view',
  props<{ exhibitor_id: string; fair_id: string }>()
);

export const exhibitorsContactPersonPageView = createAction(
  '[Exhibitor Contact Person Page] Page view',
  props<{ exhibitor_id: string; contact_person_id: string }>()
);
